import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/CTA.css';

function CTA() {
  return (
    <section className="cta">
      <div className="cta-content">
        <h2>Make fatigue visible. Make your workplace safer.</h2>
        <p>
          Join businesses using Zella to build happier, more productive teams.
        </p>
        <div className="cta-buttons">
          <Link to="/signup" className="btn-white">Start for free</Link>
          <Link to="/login" className="btn-ghost">Log in</Link>
        </div>
      </div>
    </section>
  );
}

export default CTA;